module.exports = __webpack_public_path__ + "static/img/5299_phase_function_Paper_PointsHejduk_Prediction.907f9e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5299_phase_function_Paper_PointsHejduk_Prediction.png
// module id = UmDe
// module chunks = 0